<div class="ed15-panel" *ngIf="surveys; else noCheckIn">

    <!-- Left: ED-15 overall -->
    <div class="ed15-col ed15-col--left">
        <div class="ed15-overall-row">
            <span class="ed15-overall-label">ED-15 overall</span>
            <span class="score-chip score-chip--wellbeing">
                {{ surveys.overallScore }}
                <cdss-trend-icon [trend]="surveys.trend"></cdss-trend-icon>
            </span>
            <span class="visually-hidden" *ngIf="trendLabel">{{ trendLabel }}</span>
        </div>

        <div class="ed15-sparkline-wrap">
            <cdss-weekly-trend-sparkline
                [points]="historyPoints"
                [pointLabels]="historyLabels"
                [showLabels]="true"
                ariaLabel="ED-15 overall score, last 5 weeks">
            </cdss-weekly-trend-sparkline>
        </div>

        <div class="ed15-col__footer">
            <span class="severity-chip" [ngClass]="'severity-chip--' + severityClass(surveys.overallSeverity)">
                {{ surveys.overallSeverity }}
            </span>
            <button class="btn-view" (click)="openSurveyDetail()">
                <span class="btn-view__text">View surveys</span>
                <span class="btn-view__circle"><i class="bi bi-chevron-right"></i></span>
            </button>
        </div>
    </div>

    <!-- Right: subscales & behaviours -->
    <div class="ed15-col ed15-col--right">
        <span class="ed15-col__label">Subscales &amp; behaviours</span>

        <div class="ed15-subscales">
            <div class="ed15-subscale">
                <span class="ed15-subscale__label">Weight/shape concern</span>
                <span class="ed15-subscale__value">
                    <span class="ed15-subscale__score">{{ surveys.subscales.weightShapeConcern.score }}</span>
                    <cdss-trend-icon [trend]="surveys.trend"></cdss-trend-icon>
                    <span class="ed15-subscale__severity">{{ surveys.subscales.weightShapeConcern.severity }}</span>
                    <span class="visually-hidden" *ngIf="trendLabel">{{ trendLabel }}</span>
                </span>
            </div>
            <div class="ed15-subscale">
                <span class="ed15-subscale__label">Eating concern</span>
                <span class="ed15-subscale__value">
                    <span class="ed15-subscale__score">{{ surveys.subscales.eatingConcern.score }}</span>
                    <cdss-trend-icon [trend]="surveys.trend"></cdss-trend-icon>
                    <span class="ed15-subscale__severity">{{ surveys.subscales.eatingConcern.severity }}</span>
                    <span class="visually-hidden" *ngIf="trendLabel">{{ trendLabel }}</span>
                </span>
            </div>
        </div>

        <ul class="ed15-behaviours">
            <li class="ed15-behaviour-row" *ngFor="let row of behaviourRows; trackBy: trackByBehaviourKey">
                <span class="ed15-behaviour-row__label">{{ row.label }}</span>
                <span class="ed15-behaviour-row__value">
                    <ng-container *ngIf="row.value !== null; else notApplicable">{{ formatCount(row) }}</ng-container>
                    <ng-template #notApplicable>
                        <cdss-weekly-state-label state="notApplicable"></cdss-weekly-state-label>
                    </ng-template>
                </span>
            </li>
        </ul>
    </div>

</div>

<ng-template #noCheckIn>
    <div class="ed15-panel ed15-panel--empty">
        <cdss-weekly-state-label state="noCheckIn"></cdss-weekly-state-label>
    </div>
</ng-template>
